import React from 'react';
import CustomTurnstile from './CustomTurnstile';

const Captcha = ({ onValidationChange, setErrorMessage, setTurnstileToken }) => {
  const handleCaptchaValidation = (token) => {
    onValidationChange(true);
    setErrorMessage(null);
    if (setTurnstileToken) {
      setTurnstileToken(token);
    }
  };

  return (
    <div className="mb-4">
      <CustomTurnstile
        action="demo"
        cData="customerdata"
        refreshExpired="auto"
        fixedSize={true}
        onSuccess={(token) => {
          handleCaptchaValidation(token);
        }}
        onError={() => {
          setErrorMessage('Captcha error. Please try again.');
          onValidationChange(false);
        }}
      />
    </div>
  );
};

export default Captcha;
